export const emptyGUID = "00000000-0000-0000-0000-000000000000";
export const ptxDealerGUID = "99999999-9999-9999-9999-999999999999";
